import React from 'react'

import * as common from '../../../common'
import * as r from '../../../react-utils'

import PageReport from '../PageReport'
import Pad from '../Pad'

import styles from './RoofClaimingContractWarranty.module.css'
import RoofClaimingContractHeader from './RoofClaimingContractHeader'

export interface RoofClaimingContractWarrantyProps {
  company: string
  companyContractor: common.RoofClaimingContractorCompany | null
  customerID: string
  noPDF?: boolean
}

export default React.memo<RoofClaimingContractWarrantyProps>(
  function RoofClaimingContractWarranty({
    company,
    companyContractor,
    customerID,
    noPDF,
  }) {
    const { contractCompanyFull, shouldOfferCompanySelector } =
      r.useContractCompany(customerID)

    const companyLabel = shouldOfferCompanySelector
      ? contractCompanyFull.longName
      : companyContractor
      ? common.RoofClaimingContractorToLabel[companyContractor]
      : 'COMPANY NOT SELECTED'
    return (
      <PageReport
        company={company}
        companyBorder={false}
        autoHeight
        noPDF={noPDF}
      >
        <div className={styles['container']}>
          <Pad amt={30} />
          <RoofClaimingContractHeader />
          <Pad amt={30} />
          <h4>Warranty Provisions</h4>
          <p>
            Workmanship warranted for two (2) years from completion date on
            areas listed above. Unless otherwise noted.
          </p>
          <Pad amt={5} />
          <p>
            "Completion of work" shall mean, complete installation of materials,
            clean up and removal of tools and debris from the property. All work
            has been performed in a workmanlike manner and complies with
            applicable building codes and local regulations. The materials and
            equipment furnished will be of good quality and new unless otherwise
            required or permitted by Owner's agreement.
          </p>
          <Pad amt={5} />
          <p>
            •Warranty does not include repair or replacement of any hidden or
            concealed water, gas, alarm, A/C, electrical, utility lines, or
            internal surfaces of the building, or any sagging of eaves, rafters,
            trusses, joists, or fascia.
          </p>
          <Pad amt={5} />
          <p>
            •Warranty work does not include any repair, replacement or removal
            of any satellite dishes or solar panels
          </p>
          <Pad amt={5} />
          <p>
            •Warranty does not include cosmetic variations in wood grained
            materials, variations in the colors of roofing materials and grouts,
            discoloration of brick, wood, concrete or rock surfaces due to
            exposure to the elements or leaching of dies, minor cracking or
            roughness in concrete surfaces, minor discoloration of painted
            surfaces.
          </p>
          <Pad amt={5} />
          <p>•NO IMPLIED WARRANTY EXISTS.</p>
          <Pad amt={5} />
          <p>
            •To exercise its rights under the warranty, Owner must pay all
            outstanding amounts due {companyLabel} and deliver written notice of
            a claim to {companyLabel} before expiration of the warranty period.
            •To the extent necessary to satisfy the Warranty, {companyLabel}{' '}
            shall either repair or replace (at {companyLabel}'s option) any
            nonconforming work or materials
          </p>
          <Pad amt={5} />
          <p>
            •Owner waives any right to recover for consequential damages
            suffered as a result of defective materials or workmanship,
            including • damages for personal injury, rental expense, loss of
            use, income, profit, financing, and productivity.
          </p>
          <Pad amt={5} />
          <p>
            •The limited warranty by {companyLabel} applies to the labor only.
            Warranties pertaining to materials, is the warranty of the material
            manufacturer
          </p>
          <Pad amt={5} />
          <p>
            •The {companyLabel} labor warranty is void if the payment due to{' '}
            {companyLabel} remains unpaid ninety (90) days following completion
            of the installation or upon the occurrence of any event rendering
            the materials warranty is unavoidable, including any and all acts of
            God.
          </p>
          <Pad amt={5} />
          <p>
            •{companyLabel} will not be responsible for interior damage beyond
            expiration of labor warranty • This warranty does not apply to, and{' '}
            {companyLabel}, shall not be liable for:
          </p>
          <Pad amt={20} />
          <p>
            1. Damage to the roof due to causes beyond normal use, including,
            but not limited to:
          </p>
          <Pad amt={5} />
          <p>a) Acts of God / Extreme Weather</p>
          <Pad amt={5} />
          <p>
            b) Use of the roof for purposes other than external covering of the
            house.
          </p>
          <Pad amt={5} />
          <p> c) Damage caused by alterations made after completion of work.</p>
          <Pad amt={30} />
          <h4>Conditions</h4>
          <p>
            Payment to {companyLabel}, shall be due and payable in full upon
            completion of the work. As provided in the CONTRACT, owner further
            agrees that there may be a mechanic's lien applied to this property
            if payment is not made. ONLY upon written acceptance by{' '}
            {companyLabel}, or by an authorized Agent shall this CONTRACT become
            binding. The customer shall be responsible for any and all legal
            collection charges will be added in the event of nonpayment.
          </p>
          <Pad amt={10} />
          <p>1.{companyLabel} management must approve all proposals.</p>
          <Pad amt={5} />
          <p>
            2.Interest shall accrue on all unpaid balances at the rate of 2% per
            month until paid in full.
          </p>
          <Pad amt={5} />
          <p>
            3.{companyLabel} may place a pre-lien on the project/property within
            20 days of the start of the project. If payment is not received
            according to the contract terms. alien may then be placed on the
            project/property.
          </p>
          <Pad amt={5} />
          <p>
            4.Owner agrees to pay all court costs and legal fees incurred by{' '}
            {companyLabel} in collecting any unpaid balance, including the cost
            of demand letter preparation and delivery.
          </p>
          <Pad amt={5} />
          <p>
            5.Cooperation by Owner. Owner shall not interfere with the course of
            work by {companyLabel} Owner will ensure that all areas adjacent or
            near the edges of the roof are kept free of children, pets and
            breakable property and shall ensure that all animals are penned or
            restrained during times when laborers are accessing the roof. Upon
            request by {companyLabel} Owner will move any items from the
            perimeter of the roof.
          </p>
          <Pad amt={5} />
          <p>
            6.Owner agrees to indemnify and hold {companyLabel} harmless from
            any liability for injury suffered by Owner or its invitees on the
            Property, include the cost of legal fees and costs associated with
            defending any such claims. Owner recognizes that while work is in
            progress the project and its surrounding areas may present hazardous
            conditions, and Owner and its invitees assume all risk of injury
            suffered while at the site.
          </p>
          <Pad amt={5} />
          <p>
            7.Owner is liable for the replacement cost of any delivered but
            uninstalled materials removed from the premises without{' '}
            {companyLabel}
            ’s consent. 8.Throughout construction, and for 30 days after
            completion, {companyLabel} shall be permitted to post aesthetically
            pleasing signs and notices identifying {companyLabel} as the roofer.
          </p>
          <Pad amt={5} />
          <p>
            8.Throughout construction, and for 30 days after completion,{' '}
            {companyLabel} shall be permitted to post aesthetically pleasing
            signs and notices identifying {companyLabel} as the roofer.
          </p>
          <Pad amt={5} />
          <p>
            9.Owner shall immediately disclose to {companyLabel} all conditions
            affecting the safety of the Property or impacting on the Work,
            including, but not limited to any and all concealed or unforeseen
            utilities or facilities with the Property. Contractor shall not be
            liable for any damages resulting from Owner's failure to disclose.
          </p>
          <Pad amt={5} />
          <p>
            10. {companyLabel} shall not be responsible for cracks greater than
            1/8th inch in roofing, waterproofing, or deck system that develop in
            the substrate after the installation of materials. These
            cracks/ruptures shall be deemed due to structural movement.
          </p>
          <Pad amt={5} />
          <p>11. Time is of the essence as to each part of this Agreement</p>
          <Pad amt={5} />
          <p>
            12. Property owner agrees to carry all appropriate property
            insurance.
          </p>
          <Pad amt={5} />
          <p>
            13. This contract constitutes the entire understanding, collateral
            or otherwise, and shall be binding unless specified in writing
            signed by both parties.
          </p>
          <Pad amt={5} />
          <p>
            14. The replacement of deteriorated decking, fascia boards, roof
            stacks, flashing, ventilators, or other materials, unless otherwise
            stated in the contract, are not included and may be charged as an
            extra on a time and material basis
          </p>
          <Pad amt={5} />
          <p>
            15. This proposal will expire in thirty (30) days from date unless
            extended in the writing by the company {companyLabel}. Fluctuations
            in the cost of materials may result in a revision of our price as
            necessary with costs in effect at that time.
          </p>
          <Pad amt={5} />
          <p>
            16. If it becomes necessary to reorder or restock, due to a
            cancellation, a fee of up to fifteen percent (20%) of the contract
            prices will be invoiced.
          </p>
          <Pad amt={5} />
          <p>
            17. The company ({companyLabel}) will not be responsible for
            punctured a/c lines, cracked cement or damaged property which could
            be averted with customer's due diligence and reasonable notice.
          </p>
          <Pad amt={10} />
          <p>
            Purchaser hereby acknowledges that the contractor may be subject to
            delay by inclement weather, material supply shortages or labor
            disputes beyond the control of the contractor, and purchaser herby
            accepts any delay occasioned by one or all of these occurrences in
            the installation of his roof.
          </p>
          <Pad amt={5} />
        </div>
      </PageReport>
    )
  },
)
